import { Injectable } from '@angular/core';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { INote } from '../../typings/interfaces/note.interface';

@Injectable()
export class ImNote {
  constructor(private imUser: ImUser) {
    // empty block
  }

  createdByEmail(note: INote) {
    return this.imUser.getEffectiveEmail(note.createdBy);
  }

  supportName(note: INote) {
    const { support, studentSupport } = note.attachments;
    if (support) {
      return support.name;
    } else if (studentSupport) {
      return studentSupport.support.name;
    }
  }
}
